import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TextService } from '../../../shared/services/text.service';
import { SessionService } from '../../../shared/services/session.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';

@Component({
  selector: 'pa-parental-leave-not-ok',
  templateUrl: './parental-leave-not-ok.component.html',
  styleUrls: ['./parental-leave-not-ok.component.scss'],
})
export class ParentalLeaveNotOkComponent implements OnInit {
  textService: TextService;
  sdkInitTexts: Array<SdkInitText>;

  constructor(
    private route: ActivatedRoute,
    private sessionService: SessionService,
    textService: TextService
  ) {
    this.textService = textService;
    this.browserBackButtonBlocking();
  }

  ngOnInit(): void {
    this.route.params.subscribe(
      (params) => {
        if (params.trackingId) {
          this.sessionService
            .getInitUser(params.trackingId)
            .subscribe((response) => {
              if (response === null || response.sdkInitTexts === null) {
                this.sdkInitTexts = new Array<SdkInitText>();
              } else {
                this.sdkInitTexts = response.sdkInitTexts;
              }
            });
        } else {
          this.sdkInitTexts = new Array<SdkInitText>();
        }
      },
      (error) => {
        this.sdkInitTexts = new Array<SdkInitText>();
      }
    );
  }

  browserBackButtonBlocking() {
    this.route.params.subscribe((params) => {
      if (params.trackingId) {
        history.pushState(null, null, location.href);
        history.back();
        history.forward();
        window.onpopstate = function () {
          history.go(1);
        };
      }
    });
  }
}